"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badge = exports.container = void 0;

var _util = require("../../../util");

const container = () => ({
  position: 'relative',
  zIndex: 0
});

exports.container = container;

const badge = ({
  cssProps,
  theme
}) => {
  const {
    variant = 'primary'
  } = cssProps;
  const variantTheme = theme.notificationBadges[variant];
  return {
    background: (0, _util.color)(theme, variantTheme.background),
    borderRadius: variantTheme.size,
    boxShadow: (0, _util.boxShadow)(theme, variantTheme.boxShadow),
    minWidth: variantTheme.size,
    padding: (0, _util.spacing)(theme, variantTheme.padding),
    position: 'absolute',
    right: 0,
    top: 0,
    transform: 'translate(30%, -30%)',
    zIndex: 1,
    height: variantTheme.size
  };
};

exports.badge = badge;
//# sourceMappingURL=NotificationBadge.style.js.map